import { lang } from '@umu/ukit-lang';
/**
 * @description menuIItem
 * @author duanjun
 */

import React, { useState, useEffect } from 'react';
import './menuItemUnreadCount.scss';

import API from '@umu/umu-api';
import { fetch } from '@umu/umu-fetch';
import { components } from 'common';
const { If } = components;

interface IMessageCount {
    first_page: number;
    praise: number;
    reply: number;
    system: number;
    task: number;
    total_num: number;
}

let defaultCount = 0;

function useUnReadMessageCount() {
    const [count, setCount] = useState(defaultCount);
    useEffect(() => {
        fetch.get(API.Path.GET_UNREAD_MESSAGE_COUNT.url).then((response: { data: IMessageCount }) => {
            defaultCount = response.data.total_num;
            setCount(parseInt(String(response.data.total_num || 0), 10));
        });
    }, []);
    return count;
}

export default function UnReadCount() {
    const count = useUnReadMessageCount();
    return (
        <div className="unread-count-menu-item">
            <a href="/message">
                {lang('消息中心')}
                <If condition={!!count}>
                    <span className="unread-message-count">
                        <span className="system-red-spot">{count}</span>
                    </span>
                </If>
            </a>
        </div>
    );
}
